module.exports = __webpack_public_path__ + "static/media/selected.317a55d4.svg";